import styled from "styled-components";
import { HeadLine3, BodyMedium, BodySmall } from '../../../../../components/typography/styled'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: 20px;
  padding-right: 10px;
`

export const TopInfoWrapper = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  gap: 10px;
`

export const ResourceBlock = styled.div`
  background-color: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 8px;
  padding: 20px;
  flex: 1;
  min-width: 280px;
  display: flex;
  flex-direction: column;
  gap: 10px;
`

export const ResourceTitle = styled(HeadLine3)`
  color: ${({ theme }) => theme.palette[800]};
  margin-bottom: 5px;
`

export const ResourceValue = styled(BodyMedium)`
  color: ${({ theme }) => theme.palette[700]};
  font-weight: 600;
`

export const ResourceBar = styled.div`
  width: 100%;
  height: 8px;
  background-color: ${({ theme }) => theme.grey[200]};
  border-radius: 4px;
  overflow: hidden;
  margin: 5px 0;
`

export const ResourceBarFill = styled.div<{ percentage: number }>`
  height: 100%;
  width: ${({ percentage }) => percentage}%;
  background-color: ${({ percentage, theme }) =>
    percentage > 90 ? theme.errors[500] :
    percentage > 75 ? '#E8B533' :
    '#229B61'
  };
  transition: width 0.3s ease, background-color 0.3s ease;
  border-radius: 4px;
`

export const ResourceInfo = styled(BodySmall)`
  color: ${({ theme }) => theme.palette[600]};
`

export const CpuInfoSection = styled.div`
  margin-top: 30px;
  background-color: ${({ theme }) => theme.palette[50]};
  border: 1px solid ${({ theme }) => theme.grey[300]};
  border-radius: 8px;
  padding: 20px;
  margin-right: 10px;
`

export const CpuInfoGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 15px;
  margin-top: 15px;
`

export const CpuInfoItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`

export const CpuInfoLabel = styled(BodySmall)`
  color: ${({ theme }) => theme.palette[600]};
  font-weight: 600;
  text-transform: capitalize;
`

export const CpuInfoValue = styled(BodyMedium)`
  color: ${({ theme }) => theme.palette[800]};
  word-break: break-word;
`
